























import { Vue, Component } from 'vue-property-decorator'
interface route {
  title: string
  to: string
}
@Component({
  name: 'MyApproval'
})
export default class extends Vue {
  showNav = true
  routeList: route[] = [
    {
      title: 'VIP基本信息',
      to: '/trade/trade-vip-info/base-info'
    },
    {
      title: 'VIP设备重签次数',
      to: '/trade/trade-vip-info/resign-times'
    },
    {
      title: 'VIP设备转移记录',
      to: '/trade/trade-vip-info/resign-record'
    }
  ]
}
